module.exports = __webpack_public_path__ + "img/Nav_Fold_Light.44097358.svg";